import { AnyAction, Dispatch, combineReducers } from '@reduxjs/toolkit';
import { Env } from 'config';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';

import appReducer from 'pages/AppManagement/slice';
import authReducer from 'pages/AuthenticationManagement/slice';
import uploadReducer, { resetState as uploadReset } from 'pages/UploadManagement/slice';
import assetsReducer, { resetState as assetsReset } from 'pages/AssetsManagement/slice';
import infraReducer, { resetState as infraReset } from 'pages/InfraManagement/slice';
import ctaReducer, { resetState as ctaReset } from 'pages/DashboardManagement/slice';
import analyticsReducer, { resetState as analyticsReset } from 'pages/AnalyticsManagement/slice';
import leadsReducer, { resetState as leadsReset } from 'pages/LeadsManagement/slice';
import curationReducer, { resetState as curationReset } from 'pages/CurationManagement/slice';
import feedsReducer, { resetState as feedsReset } from 'pages/FeedManagement/slice';
import courseReducer, { resetState as courseReset } from 'pages/CoursesManagement/slice';
import settingReducer, { resetState as settingsReset } from 'pages/SettingsManagement/slice';
import uploadFormReducer, { resetState as uploadFormReset } from '../containers/UploadForm/slice';

import { baseApi } from '../config/apiBase';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
  reduxTravelling: Env.isDev(),
  savePreviousLocations: 1
});

export const resetAllState = (dispatch: Dispatch<AnyAction>) => {
  dispatch(uploadReset());
  dispatch(assetsReset());
  dispatch(infraReset());
  dispatch(ctaReset());
  dispatch(uploadFormReset());
  dispatch(analyticsReset());
  dispatch(leadsReset());
  dispatch(curationReset());
  dispatch(feedsReset());
  dispatch(courseReset());
  dispatch(settingsReset());
};

const rootReducer = combineReducers({
  router: routerReducer,
  appManagement: appReducer,
  authManagement: authReducer,
  uploadManagement: uploadReducer,
  assetsManagement: assetsReducer,
  infraManagement: infraReducer,
  ctaManagement: ctaReducer,
  uploadFormManagement: uploadFormReducer,
  analyticsManagement: analyticsReducer,
  leadsManagement: leadsReducer,
  curationManagement: curationReducer,
  feedManagement: feedsReducer,
  courseManagement: courseReducer,
  settingManagement: settingReducer,
  [baseApi.reducerPath]: baseApi.reducer
});

export { routerMiddleware, createReduxHistory, rootReducer };
